import React from 'react';

import {Separator} from 'src/components/separator';

import {Group, Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';

export const EventCodeGenerationTour = () => {
    return (
        <Group direction="v" className="pt-s">
            <Group direction="v">
                <Item><strong>AI Code Generation</strong></Item>
                <Separator/>
                <Group gap="s">
                    <Item><strong>Click</strong></Item>
                    <BasicIconButton iconProps={{type: Icons.SPARKLES, size: Sizes.Size_16}}/>
                    <Item><strong>to generate code with AI.</strong></Item>
                </Group>
                <Item>Generation is based on the description and event data.</Item>
            </Group>
        </Group>
    );
};
